module.exports = __webpack_public_path__ + "static/logo-54f0fcbcbb32cc88ced5c78e82a4701e.png";